var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _clipPath, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37.265,
    height: 36.262,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 112.71 109.68",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 62.78,
    y1: 127.19,
    x2: 43.92,
    y2: 28.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    x1: 53.87,
    y1: 115.73,
    x2: 59.91,
    y2: -32.21
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 54.37,
    y1: 40.45,
    x2: 63.43,
    y2: 101.58
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 73.26,
    y1: 125.16,
    x2: 54.4,
    y2: 26.33
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 73.36,
    y1: 125.1,
    x2: 54.51,
    y2: 26.3
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id6",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 66.19,
    y1: 123.7,
    x2: 47.33,
    y2: 29.98
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 59.63,
    y1: 126.93,
    x2: 40.77,
    y2: 30.75
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id8",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 99.38,
    y1: 120.23,
    x2: 80.92,
    y2: 21.37
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.77 10.2c21.01 0 38.03 17.03 38.03 38.03 0 21.01-17.03 38.03-38.03 38.03-21.01 0-38.03-17.03-38.03-38.03 0-21.01 17.03-38.03 38.03-38.03z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fil9{fill:#0038b8}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.71 54.85c0 5.87-.94 11.5-2.7 16.8-3.2 9.72-9.12 18.24-16.87 24.72a55.31 55.31 0 0 1-11.59 7.53c-7.57 3.71-16.13 5.78-25.18 5.78-17.4 0-32.97-7.67-43.3-19.74a54.057 54.057 0 0 1-10.66-19.2A53.531 53.531 0 0 1 0 54.85c0-1.98.11-3.92.31-5.83.33-3.02.92-5.98 1.72-8.85.47-1.67 1.03-3.3 1.68-4.89a51.32 51.32 0 0 1 5-9.72c3.33-5.18 7.57-9.76 12.47-13.57 1.39-1.09 2.84-2.13 4.36-3.06C34.39 3.27 44.98 0 56.37 0 72.1 0 86.33 6.28 96.54 16.41c2.52 2.48 4.8 5.2 6.77 8.11.31.41.58.83.85 1.26 1.68 2.59 3.11 5.31 4.31 8.15 1.99 4.65 3.31 9.63 3.89 14.83.24 2 .36 4.02.36 6.09z",
    style: {
      fill: "url(#id2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73 48.24c0 .57 0 1.11-.05 1.66-.07 2.63-.35 5.19-.85 7.68-.38 1.87-.85 3.68-1.42 5.45-.12.4-.26.78-.4 1.19-.38 1.11-.83 2.2-1.28 3.3-.88 2.01-1.89 3.94-3.01 5.81-.9 1.45-1.87 2.87-2.91 4.22a47.803 47.803 0 0 1-5.28 5.81c-.5.5-1.02.95-1.54 1.4-2.3 2.02-4.81 3.8-7.49 5.31-.78.48-1.59.9-2.42 1.3a46.233 46.233 0 0 1-12.39 4.2c-2.96.59-6.02.9-9.14.9-7.82 0-15.19-1.88-21.7-5.17a47.26 47.26 0 0 1-9.43-6.26c-2.13-1.81-4.1-3.79-5.9-5.93a46.25 46.25 0 0 1-5-7.3c-1.16-2.02-2.15-4.1-2.98-6.28a38.97 38.97 0 0 1-1.14-3.3c-.26-.9-.52-1.82-.74-2.75-.42-1.76-.76-3.56-.95-5.41-.26-1.9-.38-3.86-.38-5.83 0-1.73.1-3.44.29-5.12.28-2.66.78-5.27 1.47-7.78.19-.71.4-1.42.64-2.11.24-.76.5-1.49.78-2.2.36-.95.76-1.87 1.19-2.8.62-1.42 1.35-2.8 2.13-4.15.31-.55.64-1.07.97-1.59 1.11-1.78 2.32-3.46 3.65-5.05 2.09-2.54 4.45-4.84 7.01-6.88 1.04-.85 2.13-1.66 3.3-2.42.14-.09.28-.19.43-.28a43.75 43.75 0 0 1 5.71-3.21C41.16 1.67 48.17.01 55.56.01c7.03 0 13.72 1.51 19.76 4.24 1.99.88 3.91 1.92 5.76 3.08 3.22 2.01 6.18 4.41 8.84 7.11l.05.05c1.16 1.16 2.25 2.4 3.29 3.7.85 1.07 1.68 2.2 2.44 3.37.26.38.5.74.74 1.11a47.85 47.85 0 0 1 3.67 7.16c.4.97.78 1.97 1.11 2.98.62 1.83 1.14 3.7 1.52 5.6.31 1.47.54 2.96.71 4.46.05.43.1.83.12 1.26.14 1.35.19 2.73.19 4.1z",
    style: {
      fill: "url(#id3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49 90.06c-.78.48-1.59.9-2.42 1.3a46.233 46.233 0 0 1-12.39 4.2C54.37 94.44 44.05 92 33.83 91.29a47.26 47.26 0 0 1-9.43-6.26c7.18-.41 14.47.33 21.94 1.49 9.12 1.43 18.27 3.53 27.51 3.53.83 0 3.1.05 5.64 0z",
    style: {
      fill: "url(#id7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.29 73.11c3.44.78 11.59 1.78 17.51 4.44a47.803 47.803 0 0 1-5.28 5.81c-2.25-2.32-7.58-2.94-9.57-3.44-18.2-4.55-36.94-6.28-55.56-8.02-1.97-.19-5.74-.02-9.88-.09-1.16-2.02-2.15-4.1-2.98-6.28 3.79.31 8.62.05 10.66.24 18.45 1.66 37.01 3.25 55.11 7.35z",
    style: {
      fill: "url(#id1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72 19.83c-21.91 1.95-44.02 1.52-65.91 4.25.31-.55.64-1.07.97-1.59 1.11-1.78 2.32-3.46 3.65-5.05 4.6-.17 8.89-.12 11.89-.29 17.93-.99 36.01-.28 53.88-1.97 1.89-.19 3.82-.38 5.73-.69 1.16 1.16 2.25 2.4 3.29 3.7-4.86 1-9.88 1.3-13.5 1.63z",
    style: {
      fill: "url(#id5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.65 68.06c2.25-.03 3.91-.24 5.07-.55-.88 2.01-1.89 3.94-3.01 5.81-.76.05-1.47.07-2.06.07-9.36.09-18.91-2.78-28.1-3.98-6.66-.86-13.17-1.78-19.64-3.58-9.71-2.7-19.31-6.88-29.57-6.93-1.09 0-5.33-.05-8.7.57-.42-1.76-.76-3.56-.95-5.41 2.2-.47 4.26-.74 5.76-.85 14.79-1.14 28.34 6.19 42.46 9.18 7.56 1.59 15.4 2.18 23.01 3.46 5.21.85 10.42 2.27 15.73 2.2z",
    style: {
      fill: "url(#id6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78 33.3c-.36-.02-.71-.05-1.07-.07.24-.76.5-1.49.78-2.2.36-.95.76-1.87 1.19-2.8 4.9.71 10.64.33 15.28.64 10.8.74 21.61 1.4 32.41 1.99 13.93.78 27.86 1.42 41.82 1.97.62 1.83 1.14 3.7 1.52 5.6-17.53-.69-35.06-1.52-52.6-2.54-13.13-.76-26.23-1.63-39.33-2.58z",
    style: {
      fill: "url(#id4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.38 50.46c-8.08 1.09-16.39 1.12-24.61 1.16 7.34 5.48 18.41 4.34 27.06 5.95-.38 1.87-.85 3.68-1.42 5.45-.12.4-.26.78-.4 1.19-1.25-1.07-3.62-2.06-6.16-2.4-10.47-1.4-20.92-2.3-27.46-11.45-1.23-1.75.45-3.93 2.3-4.03 8.79-.38 17.65-.29 26.39-1.02 2.58-.21 5.04-.62 7.46-1.18.14 1.35.19 2.73.19 4.1 0 .57 0 1.11-.05 1.66-1.09.24-2.18.43-3.29.57z",
    style: {
      fill: "url(#id8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77 10.2c21.01 0 38.03 17.03 38.03 38.03 0 21.01-17.03 38.03-38.03 38.03-21.01 0-38.03-17.03-38.03-38.03 0-21.01 17.03-38.03 38.03-38.03z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2044773651136"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil9",
    d: "M2.06 28.71h107.41V16.5H2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M2.06 79.97h107.41v-12.2H2.06zM55.73 59.72l-1.71-3.03 3.52.02-1.8 3.02zm6.5-5.73c.11-.3 1.6-2.87 1.77-3.01L65.71 54l-3.49-.01zm-14.69-3c.15.13 1.64 2.7 1.75 3.01l-3.5-.04 1.75-2.98zm4.85 3c-.34-.89-3.26-5.41-3.23-5.79.03-.4 2.87-4.79 3.23-5.73h6.74c.35.89 3.26 5.41 3.23 5.79-.03.4-2.87 4.79-3.23 5.73h-6.74zm11.59-8.52c-.15-.13-1.64-2.7-1.75-3l.33-.01 2.85-.01.32.04-1.75 2.98zM45.8 42.48l.31-.02h2.85l.33.01c-.12.32-1.58 2.86-1.77 3.01l-1.71-3.01zm9.99-5.74 1.71 3.03-3.52-.01 1.8-3.02zm-4.92 3.03-9.71.01c.26.63.83 1.52 1.19 2.11.4.67.8 1.38 1.2 2.08.3.53 2.39 4.01 2.4 4.23.02.26-.95 1.76-1.14 2.11l-2.42 4.21c-.38.63-.95 1.52-1.22 2.16h9.71l3.63 6.27c.26.44 1.01 1.86 1.26 2.11.22-.22 4.63-7.91 4.89-8.38l9.72-.01c-.46-1.12-4.76-8.02-4.78-8.42-.02-.26 2.09-3.73 2.37-4.24.49-.87 2.17-3.67 2.41-4.24h-9.72l-4.89-8.38-4.89 8.38z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M55.77 10.2c21.01 0 38.03 17.03 38.03 38.03 0 21.01-17.03 38.03-38.03 38.03-21.01 0-38.03-17.03-38.03-38.03 0-21.01 17.03-38.03 38.03-38.03z",
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.22df92d7c3184dfe8a46fa0800aa0cf1.svg";
export { ForwardRef as ReactComponent };